import React from 'react';
// locals
import BlockMsg from '../components/BlockMsg';
import { Button } from '@mui/material';
function TooLargeMessage({ model, }) {
    const { regionTooLargeReason } = model;
    return (React.createElement(BlockMsg, { severity: "warning", action: React.createElement(Button, { onClick: () => {
                model.setFeatureDensityStatsLimit(model.featureDensityStats);
                model.reload();
            } }, "Force load"), message: [
            regionTooLargeReason,
            'Zoom in to see features or force load (may be slow)',
        ]
            .filter(f => !!f)
            .join('. ') }));
}
export default TooLargeMessage;
